import Breadcumb from '../../components/Breadcumb'
import ListedItems from '../../components/ListedItems'


const DiscoverContainer = () => {

  return (
    <>
      <Breadcumb  
        namePage='Discover'
        title='Discover'
      />
      <ListedItems />
    </>
  );
}

export default DiscoverContainer;